// Ref: https://chakra-ui.com/docs/components/checkbox/theming#customizing-the-default-theme

import { checkboxAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
    createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const baseStyle = definePartsStyle({
    label: {
        ml: 0,
    },
});

const circular = definePartsStyle({
    control: defineStyle({
        rounded: 'full',
    }),
});

const sizes = {
    xlSmallLabel: definePartsStyle({
        control: defineStyle({
            boxSize: 7,
        }),
        label: defineStyle({
            fontSize: 'sm',
            marginLeft: 1,
        }),
    }),
    xs: definePartsStyle({
        control: defineStyle({
            boxSize: 3,
        }),
        icon: defineStyle({
            fontSize: '2xs',
        }),
        label: defineStyle({
            fontSize: 'xs',
            marginLeft: 1,
        }),
    }),
};

const checkboxTheme = defineMultiStyleConfig({
    baseStyle,
    variants: { circular },
    sizes,
});

export default checkboxTheme;
